import script from "./SupportRequestCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportRequestCompleted.vue?vue&type=script&setup=true&lang=js"

import "./SupportRequestCompleted.vue?vue&type=style&index=0&id=69afaa89&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69afaa89"]])

export default __exports__